import { ProductsSortByEnum } from '@tiendanube/common/src/domains/products/enums';

export const LIMIT_PRODUCTS_SELECTED = 40;
export const SORT_BY_CREATED_AT_DESCENDING =
  ProductsSortByEnum.CREATED_AT_DESCENDING;
